module.exports = __webpack_public_path__ + "img/brief_picture_05.900d45c7.png";